var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.5 20.1",
    style: {
      enableBackground: "new 0 0 22.5 20.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4,0c-5.2,0-9.5,4-10,9.1H1c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1h7.7c0.4,0,0.7-0.2,0.9-0.5l0.8-1.6l2.5,4.9 c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.7-0.2,0.9-0.5l1.4-2.8h1.4c0.5,0,1-0.4,1-1c0-0.5-0.4-1-1-1h-2c-0.4,0-0.7,0.2-0.9,0.5l-0.8,1.6 l-2.5-4.9c-0.3-0.7-1.4-0.7-1.8,0L8.1,9.1H4.4c0.5-4,3.9-7.1,8-7.1c4.4,0,8.1,3.6,8.1,8.1c0,4.5-3.6,8.1-8.1,8.1 c-3.4,0-6.3-2.1-7.5-5H2.8c1.3,4,5.1,7,9.6,7c5.5,0,10.1-4.5,10.1-10.1C22.5,4.5,18,0,12.4,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceStatusIcon);
export default __webpack_public_path__ + "static/media/device_status_icon.b0b538b1ef5391fda9ad1cfc3ceb60f5.svg";
export { ForwardRef as ReactComponent };